module.exports = {
  __depends__: [
    require('diagram-js/lib/i18n/translate')
  ],
  bpmnImporter: [ 'type', require('./BpmnImporter') ]
};


// WEBPACK FOOTER //
// ./~/bpmn-js/lib/import/index.js